<template>
  <section class="lead-table">
    <b-table
      :data="followups"
      :paginated="isPaginated"
      :per-page="perPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="s_title"
        sortable
        searchable
        label="Lead Status"
        v-slot="props"
      >
        {{ props.row.s_title }}
      </b-table-column>
      <b-table-column
        field="priority"
        sortable
        searchable
        label="Priority"
        v-slot="props"
      >
        {{ props.row.priority }}
      </b-table-column>
      <b-table-column
        field="fullname"
        sortable
        searchable
        label="Lead Name"
        v-slot="props"
      >
        <router-link :to="'/lead/' + props.row.lead_id">
          {{ props.row.fullname }}
        </router-link>
      </b-table-column>
      <b-table-column
        field="agentName"
        sortable
        searchable
        label="Agent Name"
        v-slot="props"
        v-if="user.role_id === 1"
      >
        {{ props.row.agentName }}
      </b-table-column>
      <b-table-column
        field="datetime"
        sortable
        searchable
        label="Date/Time"
        v-slot="props"
      >
        {{ props.row.datetime }}
      </b-table-column>
      <b-table-column
        field="description"
        sortable
        searchable
        label="Description"
        v-slot="props"
      >
        {{ props.row.description }}
      </b-table-column>
      <b-table-column
        cellClass="do-not-decorate"
        fields="id"
        label="Actions"
        v-slot="props"
      >
        <FollowUpsTableActions :followup="props.row" />
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import FollowUpsTableActions from "@/components/forms/FollowUpsTableActions";
export default {
  name: "FollowUpsTableVue",
  components: {
    FollowUpsTableActions,
  },
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      perPage: 20,
    };
  },
  props: ["followups", "user"],
};
</script>

<style lang="scss">
.do-not-decorate:hover {
  text-decoration: none !important;
}
</style>